<script>
import BaseView from "@/mixins/BaseView.vue";
import DriversList from "@/views/drivers/components/DriversList.vue";
import DriversSearchForm from "@/views/drivers/components/DriversSearchForm.vue";
import PageHeader from "@/components/header/PageHeader.vue";
import CreateNewUserButton from "@/components/buttons/CreateNewUserButton.vue";

export default {
  name: "DriversPage",
  components: { CreateNewUserButton, PageHeader, DriversSearchForm, DriversList },
  mixins: [BaseView],
  data() {
    return {
      perm: "drivers",
      searchParams: {},
    };
  },
  created() {
    this.setTitle(this.$t("drivers.drivers"));
  },
  methods: {
    async search(params) {
      this.searchParams = { ...params };
    },
  },
};
</script>

<template>
  <v-container :fluid="true" class="pt-6 pb-10 pl-6 pr-6 height-100 drivers-page">
    <page-header :header="$t('users.drivers')">
      <template #suffix>
        <create-new-user-button />
      </template>
    </page-header>
    <drivers-search-form @search="search" />
    <drivers-list :search-params="searchParams" show-owners />
  </v-container>
</template>
